import React from 'react';
import {
  FaRocket,
  FaCode,
  FaMobileAlt,
  FaMapMarkerAlt,
  FaArrowRight,
  FaCheckCircle,
  FaIndustry,
  FaLeaf,
} from 'react-icons/fa';

const Hero = () => {
  const stats = [
    { value: '10+', label: 'Solutions développées' },
    { value: '5+', label: "Années d'expérience" },
    { value: '100%', label: 'Engagement qualité' },
  ];

  const domains = [
    { icon: <FaCode />, label: 'Informatique & numérique' },
    { icon: <FaIndustry />, label: 'Ingénierie & IBTP' },
    { icon: <FaLeaf />, label: 'Agriculture & agrotech' },
    { icon: <FaMapMarkerAlt />, label: 'Tracking & géolocalisation' },
  ];

  return (
    <section id="accueil" className="hero">
      <div className="hero-bg-pattern"></div>
      <div className="container hero-container">
        <div className="hero-content">
          <span className="hero-badge">
            <span className="hero-badge-dot"></span>
            Entreprise de développement — RDC
          </span>
          <h1 className="hero-title">
            L'innovation au service du <span className="text-gradient">développement</span> africain
          </h1>
          <p className="hero-subtitle">
            Livia Tech conçoit et développe des solutions technologiques, numériques et professionnelles
            adaptées aux réalités africaines. De l'informatique à l'ingénierie, de l'agriculture aux
            plateformes digitales, nous transformons les idées en solutions concrètes.
          </p>

          <div className="hero-buttons">
            <a
              href="https://www.zwacop.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-lg"
            >
              Découvrir ZWACOP <FaArrowRight className="btn-icon" />
            </a>
            <a href="#services" className="btn btn-outline btn-lg">
              Nos solutions
            </a>
          </div>

          <div className="hero-stats">
            {stats.map((stat, index) => (
              <div className="hero-stat" key={index}>
                <span className="hero-stat-value">{stat.value}</span>
                <span className="hero-stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-visual-main">
            <div className="hero-visual-core">
              <div className="hero-visual-core-icon">
                <FaRocket />
              </div>
              <div className="hero-visual-core-ring"></div>
            </div>

            <div className="hero-visual-card hero-visual-card-1">
              <div className="hero-visual-icon"><FaCode /></div>
              <div className="hero-visual-info">
                <span className="hero-visual-title">Solutions numériques</span>
                <span className="hero-visual-desc">Plateformes & applications</span>
              </div>
            </div>

            <div className="hero-visual-card hero-visual-card-2">
              <div className="hero-visual-icon"><FaMobileAlt /></div>
              <div className="hero-visual-info">
                <span className="hero-visual-title">Innovation technologique</span>
                <span className="hero-visual-desc">Solutions adaptées</span>
              </div>
            </div>

            <div className="hero-visual-card hero-visual-card-3">
              <div className="hero-visual-icon"><FaCheckCircle /></div>
              <div className="hero-visual-info">
                <span className="hero-visual-title">Développement concret</span>
                <span className="hero-visual-desc">Impact réel sur le terrain</span>
              </div>
            </div>
          </div>

          <div className="hero-domains">
            {domains.map((domain, index) => (
              <div className="hero-domain-chip" key={index}>
                <span className="hero-domain-icon">{domain.icon}</span>
                {domain.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;